import React from "react";

import { Container,  Col, Row } from "react-bootstrap";

import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
import "./experience.css";



const Dataset = [
  {
    id: "1",
    JobTitle: "UI Engineer (Frontend dev)",
    CompanyName: "AlgologAI - Abuja",
    Duration: "June 2024 - Present",
    Description: [
      "Design and implement visually appealing, responsive interfaces using Tailwind CSS to ensure a seamless user experience across devices.",
      "Write clean, maintainable code in React.js and Next.js with TypeScript, focusing on scalability and performance optimization.",
      "Integrate and consume RESTful APIs to populate the frontend with dynamic data, ensuring efficient functionality and a polished product.",
    
    ],
  },

  {
    id: "2",
    JobTitle: "Product Designer",
    CompanyName: "PalRemit - Dubai, UAE",
    Duration: "Oct 2023 - Oct 2024",
    Description: [
      "Conceptualizing original ideas that bring simplicity and user friendliness to a variety of design challenges ",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",
      "Creating process flows, site maps, wireframes, screen prototypes and functional specifications.",
    
    ],
  },
  {
    id: "3",
    JobTitle: "UI/UX Designer / Frontend dev",
    CompanyName: "Amabills - Abuja",
    Duration: "June 2022 - present",
    Description: [
      "Defining product structure and interaction through workflow,wireframes and prototypes",
      "Collaborating with other designers and front end developers to document and deliver user-centered design.",
      "Delivering great User Experience in collaboration with the production team",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",

    
    ],
  },
  {
    id: "4",
    JobTitle: "Frontend Developer & UI Designer",
    CompanyName: "Aggregate - Abuja",
    Duration: "June 2023 - Jan 2024",
    Description: [
      "Write clean, efficient, and maintainable HTML, CSS,JavaScript and React code to implement the user interface designs provided by the UI/UX designers",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",
      "Ensure cross-browser compatibility and responsiveness to deliver a seamless experience across different devices. screen sizes.",
    
    ],
  },
  {
    id: "5",
    JobTitle: "Web Designer (Contract)",
    CompanyName: "Flexisaf - Abuja",
    Duration: "June 2023 - August 2023",
    Description: [
      "Write clean, efficient, and maintainable HTML, CSS,JavaScript and React code to implement the user interface designs provided by the UI/UX designers",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",
      "Ensure cross-browser compatibility and responsiveness to deliver a seamless experience across different devices. screen sizes.",
    
    ],
  },
  {
    id: "6",
    JobTitle: "Product Designer",
    CompanyName: "CodifyCollege - Sweden",
    Duration: "June 2022 - Sept 2022",
    Description: [
      "Redesign and optimize our current digital assets for improved user experience",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",
      "Develop clear design guidelines, patterns, and assets to maintain brand consistency.",
      "Utilize analytics to refine design elements and improve user experience."
    
    ],
  },
  {
    id: "7",
    JobTitle: "UI/UX Designer",
    CompanyName: "ZKYTE - Abuja",
    Duration: "May 2021 - June 2022",
    Description: [
      "Applying advanced artistic ability to create stunning graphics, digital assets, and interfaces that ‘wow’ users and deliver amazing user experiences. ",
      "Develop hi-fidelity visual prototypes and quickly iterate on versions based on design critiques from peers or learnings found in user testing",
      "Maintain design systems and libraries in conjunction with the broader Product UI Design team to ensure product-wide visual consistency",
    
    ],
  },
 
];

function Experience() {
  return (
    <Container fluid className="experiencepage">
        <Row>
            <Col xs={12} md={5} lg={5} >
            <div
          >
            <div className="aboutbody">
              <h2 style={{fontFamily:"Clash Display"}} className="aboutHeadingxxx">Job Experience</h2>
              <p style={{ fontFamily: 'Jost, sans-serif',fontSize:0.8+"rem"}}>
              These are my job experiences, affiliations with organizations that offer me a platform to demonstrate my skills.{" "}
              </p>
            </div>
          </div>
        
            </Col>
            <Col xs={12} md={7} lg={7}>
            <Carousel
        additionalTransfrom={0}
        arrows={false}
        autoPlaySpeed={3000}
        centerMode={false}
        className=""
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 1, // Adjusted to show 2.5 items
            partialVisibilityGutter: 30,
          },
          mobile: {
            breakpoint: {
              max: 550,
              min: 0,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 551,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={true}
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {Dataset.map((item) => (
         
          
              <Col fluid className="myRole" style={{color:"white",width:100+"%"}} >
              
                <h6 style={{fontFamily:"Clash Display"}} ><strong>{item.JobTitle}</strong></h6>

               
                <span style={{ fontFamily: 'Jost, sans-serif',backgroundColor:"#5B5B5B",paddingTop:0.3+"rem",paddingBottom:0.3+"rem",paddingRight:0.6+"rem",paddingLeft:0.6+"rem",width:"auto",borderRadius:1+"rem",fontSize:0.8+"rem",}}>{item.CompanyName}</span><br/>
                <span style={{ fontFamily: 'Jost, sans-serif',fontSize:0.75+"rem"}}>{item.Duration}</span>
             
                
                <br/><br/>
                {item.Description.map((i) => (
                  <ul className="listingofiitem" style={{ listStyleType:'disc', fontFamily: 'Jost, sans-serif' }} >
                    <li style={{lineHeight:183+"%"}}>{i}</li><br/>
                    
                  </ul>
                  
                ))}
               
                
              
              </Col>
           
        
        ))}
      </Carousel>
            </Col>
        </Row>
      
         

      
    </Container>
  );
}
export default Experience;
